import { useEffect, useRef, useState, type CSSProperties } from "react";

/** how long a hold button must be held: a touch through the trouser pocket must not fire it (owner 2026-10-30) */
const HOLD_MS = 1000;

/** A button that fires only after being held for `HOLD_MS`; a bar fills while it is held, letting go early cancels. */
export function HoldButton(props: { className: string; label: string; onHeld(): void }) {
  const [holding, setHolding] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  const release = () => { clearTimeout(timer.current); setHolding(false); };
  useEffect(() => () => clearTimeout(timer.current), []);
  return (
    <button className={props.className + " hold-btn" + (holding ? " holding" : "")} style={{ "--hold-ms": `${HOLD_MS}ms` } as CSSProperties}
      onPointerDown={(ev) => {
        ev.preventDefault();
        setHolding(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => { setHolding(false); props.onHeld(); }, HOLD_MS);
      }}
      onPointerUp={release} onPointerLeave={release} onPointerCancel={release}
      // a long press must not open the browser's context menu
      onContextMenu={(ev) => ev.preventDefault()}>
      <span>{props.label}</span>
    </button>
  );
}
